// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';

const ScoringContext = React.createContext({});
const VBScoringContext = React.createContext({});
const GenericScoringContext = React.createContext({});

export { ScoringContext, VBScoringContext, GenericScoringContext };
